import { AddressValidationProvider } from "@/components/Address/AddressValidation/context/addressValidation.context";

import { CheckoutCustomer } from "./checkoutCustomer.component";
import { CheckoutCustomerContextProvider } from "./checkoutCustomer.context";

type CheckoutCustomerContainerProps = {
    boxContestConditionInfo: string;
    boxPartnerConditionMicroCopy: string;
};

const CheckoutCustomerContainer = ({
    boxContestConditionInfo,
    boxPartnerConditionMicroCopy
}: CheckoutCustomerContainerProps) => (
    <AddressValidationProvider>
        <CheckoutCustomerContextProvider
            boxContestConditionInfo={boxContestConditionInfo}
            boxPartnerConditionMicroCopy={boxPartnerConditionMicroCopy}
        >
            <CheckoutCustomer />
        </CheckoutCustomerContextProvider>
    </AddressValidationProvider>
);

export { CheckoutCustomerContainer };
